import { createContext } from 'react';
import {
  CustomFieldDefinition,
  CustomFieldDefinitionWithTargets,
} from 'types/customField';

export const EventCustomFieldDefinitionsContext = createContext<
  | {
      definitions: CustomFieldDefinitionWithTargets[];
      deleteDefinition: (id: string) => Promise<void>;
      updateDefinition: (definition: CustomFieldDefinition) => Promise<void>;
      createDefinition: (definition: CustomFieldDefinition) => Promise<void>;
    }
  | undefined
>(undefined);
